import React from "react";
import { ShieldAlert } from "lucide-react";
import { StatusBadge } from "./StatusBadge";

// Permission-denied screen (master context §9.4 permission-denied state).
export function PermissionDenied({ message }: { message?: string }) {
  return (
    <div
      className="flex flex-col items-center justify-center rounded-xl border border-amber-200 bg-amber-50 py-16 text-center"
      data-testid="permission-denied"
    >
      <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-amber-100">
        <ShieldAlert className="h-6 w-6 text-amber-600" strokeWidth={1.75} />
      </div>
      <StatusBadge tone="amber">Permission denied</StatusBadge>
      <h3 className="mt-4 font-display text-xl font-medium text-slate-900">You don't have access to this</h3>
      <p className="mt-1.5 max-w-md text-sm text-slate-600">
        {message || "This area is limited to the organization owner. Ask an owner if you need access."}
      </p>
    </div>
  );
}
